import type { HTTPService } from "@soft-db/http";
import type { UserScope } from "./user-api";

export const AuditTarget = {
	ORGANIZATION: "distributor",
	STATION: "station",
	SITE: "site",
	ALERT: "alert",
	DASHBOARD: "dashboard",
	USER: "user_account",
	SPACE: "space",
	WEEKLY_LIMIT: "weekly_limit",
	VIBRATION_CRITERIA: "vibration_criteria",
	SAFE_LIMIT: "safe_limit",
	DYNAMIC_IMAGE: "dynamic_image",
	PUBLIC_PAGE: "public_page",
	REPORT: "report",
} as const;
export type AuditTarget = (typeof AuditTarget)[keyof typeof AuditTarget];

export const AuditAction = {
	UPDATED: "updated",
	CREATED: "created",
	DELETED: "deleted",
} as const;
export type AuditAction = (typeof AuditAction)[keyof typeof AuditAction];

export type AuditObjectTarget = {
	id: string;
	type: AuditTarget;
};

export type Audit = {
	target: AuditObjectTarget | null;
	parent: AuditObjectTarget | null;
	scope: UserScope;
	time: Date;
	user: string;
} & AuditEntry<Record<string, AuditChange | AuditEntry[]>>;

export type AuditEntry<TChanges = Record<string, AuditChange>> = {
	id: string;
	action: AuditAction;
	changes?: TChanges;
};

export type AuditChange = {
	before?: string | null | undefined;
	after?: string | null | undefined;
};

export type AuditQuery = {
	target?: AuditTarget;
	id?: string;
	parent?: string;
	from?: Date | string;
	to?: Date | string;
	user?: string;
	pageIndex?: number;
	pageSize?: number;
};

export type AuditSearchResponse = {
	events: Audit[];
	hasMore: boolean;
};

export class AuditApi {
	constructor(private _http: HTTPService) {}

	async fetchAudit(query: AuditQuery = {}): Promise<AuditSearchResponse> {
		return await this._http.get<AuditSearchResponse>(`audit`, { params: query }).then((r) => ({
			...r,
			events: r.events.map((audit) => ({ ...audit, time: new Date(audit.time) })),
		}));
	}
}
